<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H6C6.41421 4.25 6.75 4.58579 6.75 5C6.75 5.41421 6.41421 5.75 6 5.75H5C4.30964 5.75 3.75 6.30964 3.75 7V13C3.75 13.6904 4.30964 14.25 5 14.25H6C6.41421 14.25 6.75 14.5858 6.75 15C6.75 15.4142 6.41421 15.75 6 15.75H5C3.48122 15.75 2.25 14.5188 2.25 13V7ZM13.25 5C13.25 4.58579 13.5858 4.25 14 4.25H15C16.5188 4.25 17.75 5.48122 17.75 7L17.75 13C17.75 14.5188 16.5188 15.75 15 15.75H14C13.5858 15.75 13.25 15.4142 13.25 15C13.25 14.5858 13.5858 14.25 14 14.25H15C15.6904 14.25 16.25 13.6904 16.25 13L16.25 7C16.25 6.30964 15.6904 5.75 15 5.75H14C13.5858 5.75 13.25 5.41421 13.25 5Z"
      fill="currentColor"
    />
    <path
      d="M7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9C6.55228 9 7 9.44772 7 10Z"
      fill="currentColor"
    />
    <path
      d="M11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10Z"
      fill="currentColor"
    />
    <path
      d="M15 10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10Z"
      fill="currentColor"
    />
  </svg>
</template>
